import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type WidgetInfoHandlerType = CustomHandler;

export const ResetPerformancePerfs: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/ResetPerformanceWidgetPerfs",
    });
};

export const chain = [ResetPerformancePerfs];

const resetPerformancePerfsForPrint = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetPerformancePerfsForPrint");

export default resetPerformancePerfsForPrint;
